__turbopack_context__.v({
  "bundleProducts-container": "BundleProducts-module-scss-module__0LF9fG__bundleProducts-container",
  "bundleProducts-title": "BundleProducts-module-scss-module__0LF9fG__bundleProducts-title",
  "image-container": "BundleProducts-module-scss-module__0LF9fG__image-container",
  "product-container": "BundleProducts-module-scss-module__0LF9fG__product-container",
  "product-img": "BundleProducts-module-scss-module__0LF9fG__product-img",
  "product-name": "BundleProducts-module-scss-module__0LF9fG__product-name",
  "product-price": "BundleProducts-module-scss-module__0LF9fG__product-price",
  "productList-container": "BundleProducts-module-scss-module__0LF9fG__productList-container",
});
